// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export enum OperationType {
    Buy = 0 /* Const.VALUE_BUY replacement */,
    Sell = 1 /* Const.VALUE_SELL replacement */,
};
